import React, { useEffect } from 'react';
import {
	Container, Typography, Paper, Grid, Link, Box, List, ListItem, Divider,
	Table, TableBody, TableCell, TableHead, TableRow, Accordion, AccordionSummary, AccordionDetails
	} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Paper_football from '../assets/images/PNF/PaperFootball.jpg';

const theme = createTheme({
    typography: {
        fontFamily: [
            'Georgia',
            'serif'
        ].join(','),
        h1: {
            fontFamily: 'Linux Libertine, serif',
            fontSize: '3rem' // equivalent to 32px
        },
        h2: {
            fontFamily: 'Linux Libertine, serif',
            fontSize: '2.5rem' // equivalent to 24px
        },
        h3: {
            fontFamily: 'Linux Libertine, serif',
            fontSize: '2rem' // equivalent to 20px
        },
        h4: {
            fontFamily: 'Linux Libertine, serif',
            fontSize: '1.5rem' // equivalent to 16px
        },
        h5: {
            fontFamily: 'Linux Libertine, serif',
            fontSize: '1.25rem' // equivalent to 14px
        },
        h6: {
            fontFamily: 'Linux Libertine, serif',
            fontSize: '1rem' // equivalent to 12px
        },
        body1: {
            fontSize: '1rem' // equivalent to 16px
        },
        body2: {
            fontSize: '0.875rem' // equivalent to 14px
        },
    },
});

const PnfInfo = () => {
    const handleScroll = (event, id) => {
        event.preventDefault();
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth="lg">
                <Box my={4}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Paper Football
                    </Typography>
                    <Divider />
                    <Typography variant="h6" component="h2" gutterBottom>
                        From Namkeypedia
                    </Typography>
                </Box>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Typography variant="body1" paragraph>
                            <a style={{ fontWeight: 'bold' }}>Paper football</a>, also known as <a style={{ fontWeight: 'bold' }}>Paper Foot Game</a>,
                            is a team game played between two teams of 11 players each. The game is played inside a
                            rectangular field called a pitch, which can be placed on a table top, or on the ground,
                            using a small paper ball. The objective is to score goals by flicking the paper player
                            inside the opponent's goal, which are made by different materials. The game is a replica
                            of <Link href="https://en.wikipedia.org/wiki/Association_football" underline="hover" color="primary">Association football</Link>,
							where the players are made from paper-related material. The game, similar to football, is
							divided into 2 halves, each half's period varies from 5 to 10 minutes depends on the rules.
                        </Typography>

                        <Typography variant="body1" paragraph>
                            In terms of law, due to the unique of the paper players' body, which is folded into 2 parts,
                            the "hole" between 2 sides is considered the player's hands. Hence, a player would be
                            considered to conduct a fault if the ball comes into that hole, except the goalkeepers. A
                            goalkeeper himself can "collect" or catch the ball by holding the ball inside his hole, and
                            can just use the hand inside the <Link href="https://en.wikipedia.org/wiki/Penalty_area" underline="hover" color="primary">penalty area</Link>.
                        </Typography>

                        <Typography variant="body1" paragraph>
                            In the PNF Universe, paper football is governed by PNF. Similar to <Link href="https://en.wikipedia.org/wiki/FIFA" underline="hover" color="primary">FIFA</Link>,
                            PNF has two types of competitions, International Competitions and Club Competitions. But
                            unlike FIFA, players from both genders can play together in the same competitions. The
                            highest rank competitions are PNF World Cup and PNF Champions League.
                        </Typography>


	                    <Paper elevation={3} sx={{ padding: 3, marginBottom: 4, width: "50%", backgroundColor: "#f5f5f5" }}>
	                        <Accordion>
	                            <AccordionSummary
	                                expandIcon={<ExpandMoreIcon />}
	                                aria-controls="contents-content"
	                                id="contents-header"
	                            >
	                                <Typography variant="h4">Contents</Typography>
	                                <Divider />
	                            </AccordionSummary>
	                            <AccordionDetails>
	                                <List>
	                                    <ListItem>
	                                        <Link
	                                            href="#name"
	                                            underline="hover"
	                                            onClick={(e) => handleScroll(e, 'name')}
	                                            >Name
	                                        </Link>
	                                    </ListItem>
	                                    <ListItem>
	                                        <Link
	                                            href="#history"
	                                            underline="hover"
	                                            onClick={(e) => handleScroll(e, 'history')}
	                                            >History
	                                        </Link>
	                                    </ListItem>
	                                    <ListItem>
	                                        <Link
	                                            href="#gameplay"
	                                            underline="hover"
	                                            onClick={(e) => handleScroll(e, 'gameplay')}
	                                            >Gameplay
	                                        </Link>
	                                    </ListItem>
	                                    <ListItem>
	                                        <Link
	                                            href="#laws"
	                                            underline="hover"
	                                            onClick={(e) => handleScroll(e, 'laws')}
	                                            >Laws
	                                        </Link>
	                                    </ListItem>
	                                    <ListItem>
	                                        <Link
	                                            href="#governing-bodies"
	                                            underline="hover"
	                                            onClick={(e) => handleScroll(e, 'governing-bodies')}
	                                            >Governing bodies
	                                        </Link>
	                                    </ListItem>
	                                    <ListItem>
	                                        <Link
	                                            href="#competitions"
	                                            underline="hover"
	                                            onClick={(e) => handleScroll(e, 'competitions')}
	                                            >Competitions
	                                        </Link>
	                                    </ListItem>
	                                    <ListItem>
	                                        <Link
	                                            href="#see-also"
	                                            underline="hover"
	                                            onClick={(e) => handleScroll(e, 'see-also')}
	                                            >See also
	                                        </Link>
	                                    </ListItem>
	                                    <ListItem>
	                                        <Link href="#notes"
	                                        underline="hover"
	                                        onClick={(e) => handleScroll(e, 'notes')}
	                                        >Notes</Link></ListItem>
	                                    <ListItem>
	                                        <Link
	                                            href="#references"
	                                            underline="hover"
	                                            onClick={(e) => handleScroll(e, 'references')}
	                                            >References
	                                        </Link>
	                                    </ListItem>
	                                    <ListItem>
	                                        <Link
	                                            href="#external-links"
	                                            underline="hover"
	                                            onClick={(e) => handleScroll(e, 'external-links')}
	                                            >External links
	                                        </Link>
	                                    </ListItem>
	                                </List>
	                            </AccordionDetails>
	                        </Accordion>
	                    </Paper>

                        <Box id="name" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold'>
                                Name
                            </Typography>
                            <Divider />
                            <Typography variant="body1" paragraph>
                                The game is known as paper football, or paper foot game. The name is based on the material
                                of the ball, which is the tissue, or players' material, which is made from carton or papers.
                            </Typography>
                        </Box>

                        <Box id="history" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold'>
                                History
                            </Typography>
                            <Divider />
                            <Typography variant="body1" paragraph>
                                There is no clear evidence for the origin of paper football. But it has been received
                                significant attention after its feature in Season 4, episode "Anak Harimau" (meaning "Tiger Cubs")
                                of the cartoon series "Upin and Ipin.". With the simple rules and minimal material needed
                                to create the players, the game was getting attractiveness during that time to many people,
                                especially children and football fans.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                In Vietnam, especially in the city, the lack of entertainment for children, including
                                football fields, had become a major issue. With a modern living lifestyle, parents can't
                                spend enough time to bring their children to the entertaining places, or at least play
                                with their children that often. Hence, paper football has been one of the most popular
                                game for children, which not only brought them the joy and competitiveness similar to football,
                                but also removed the parents fear of their children injury.
                            </Typography>
                            <Typography variant="h5" component="h4" gutterBottom fontWeight='bold'>
                                Adaptation in my neighbor area
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Although I have known the game from 'Upin & Ipin', I had just started playing the game
                                since my neighbor's friend builds different teams of his own. For 5 Years (2009 - 2014),
                                hundred of matches has been played among us and other friends, being an important part
                                of our childhood memory.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                There are many strong teams in this period, two of those are "Pulu" and "Izz" Team. Pulu
                                is an adaptation of the Pulu team in Upin & Ipin, the team that has faced Malaysia in
                                the imaginary World Cup in this cartoon. Izz is the strongest rival of Pulu, and also my
                                most used team during this period.
                            </Typography>
                            <Typography variant="h5" component="h4" gutterBottom fontWeight='bold'>
                                Foundation of PNF and the first 12 clubs (2013 - 2015)
                            </Typography>
                            <Typography variant="body1" paragraph>
                                On 2013, with the need to have several teams of my own for competitions within the
                                neighborhood area, PNF (Paper-football Novel Federation) has been founded, along with 12
                                member clubs. PNF had the mission to organize the competitions among the member clubs,
                                keep the relationship with the neighboring federations for organizing friendly matches
                                or even inter-competitions.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                The first 12 teams are Frozen Team, Red (now is Manchester United), Red & White (now is
                                Arsenal, Yellow (now is Borussia Dortmund), Vietnam, Russia, England, Japan, Fascism,
                                Capitalism, Soviet FC, and Feudalism. The 12 teams are initially inspired from 3 concepts -
                                basic colors, National Football Team, and politics. The first tournament has been organized
                                in the same year, naming PNF Champions League, with Russia defeating Red team in the final.
                                6 competitions had been held during this period, where Russia participated in all of the
                                semi-finals, half of the finals, and won 2 trophies. The 4 others winners are Capitalism
                                (2nd Season), Arsenal (4th Season), Feudalism (5th Season), and Frozen Team (6th Season).
                            </Typography>
                            <Typography variant="body1" paragraph>
                                In terms of international competition, World Cup 2014 has been organized with 8 teams:
                                Russia, England, Vietnam, Japan, Northern Europe, South America, France (Open), and Germany,
                                where Northern Europe, with the core players from Frozen Team, has
                                defeated Russia in the final to gain the trophy.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Besides the federation's competition, some friendly matches, as stated above, has been
                                organized inside the neighboring area. Frozen Team, Russia, and Red team had the most
                                times participating in those matches to represent PNF in the higher level matches.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                From the late 2014, with my family movement, the competition can just been held during the weekend
                                in the old house, or during the 2015 summer. The 6th season, which is also the last one
                                being organized in my old house, ended after the winning of Frozen Team against the
                                last season's champion - Feudalism.
                            </Typography>
                            <Typography variant="h5" component="h4" gutterBottom fontWeight='bold'>
                                Expansion of PNF and its competitions (2016 - 2018)
                            </Typography>
                            <Typography variant="body1" paragraph>
                                PNF Champions League Season 7 was the first PCL editions with new teams joining, which were
                                Bayern Munich, Ninja Hattori-kun, Perman FC, and Doraemon. A special guess, Malaysia Team,
                                has been invited to join the tournament, but the team just played in the first round. The
                                competition constantly expand in the next editions, with 32 teams in the 8 and 9th seasons.
                                In the 10th PCL edition, the lower-rank competition - PNF Cup - has been introduced for
                                new teams joining PNF in this season. The system were 32 teams in PCL and 8 teams in PNF Cup.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                PNF Euro 2016 was the first competition being held in this period, with 12 national teams
                                (Russia, England, Northern Europe, France, Germany, Spain, Middle & South Europe (MSE),
                                Netherlands, Italy, Portugal, Scotland, and Romania)
                            </Typography>
                            <Typography variant="body1" paragraph>
                                PNF Euro 2016 was the first competition being held in this period, with 12 national teams
                                (Russia, England, Northern Europe, France, Germany, Spain, Middle & South Europe (MSE),
                                Netherlands, Italy, Portugal, Scotland, and Romania)
                            </Typography>
                        </Box>

                        <Box id="gameplay" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold' >
                                Gameplay
                            </Typography>
                            <Divider />
                            <Typography variant="body1" paragraph>
                                The game is played by touching the paper player with the finger, and flicking it to kick
                                the ball. The player can pass the ball to the teammates, dribble, or shoot the ball. To
                                score a goal, the player must flick the ball into the opponent's goal. Tactic is
                                developed day-by-day, either adapt from football, or improve from the old style of playing.
                            </Typography>
                        </Box>

                        <Box id="laws" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold'>
                                Laws
                            </Typography>
                            <Divider />
                            <Typography variant="body1" paragraph>
                                The laws of paper football vary, but generally include rules on scoring, fouls, and the
                                dimensions of the playing field. In PNF, the game is played with 11 players on each team.
                                The game is played inside a rectangular field called a pitch, which can be placed on a
                                table, or even on the concrete floor. If the ball is outside the pitch, the game is
                                restarted with a throw-in, a corner kick, or a goal kick by the goalkeeper. The game can
                                be played via 2-half or 1-half system, so that the total time of the game is 15 minutes.
                                Normal players can use every part of their body, except their hand (the hole between 2
                                sides of the paper player). Goalkeepers can use their hand, but only inside the penalty
                                area.
                            </Typography>
                            <Typography variant="h5" component="h3" gutterBottom fontWeight='bold'>
                                Players, equipment, and officials
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Paper football requires minimal equipment: a paper ball, 2 goals, and 22 paper players.
                                The ball is made from tissue, and should has a diameter of around 1 cm. The goals can be
                                made from different materials, such as wood, plastic, or even paper. The players are made
                            </Typography>
                        </Box>

                        <Box id="governing-bodies" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold'>
                                Governing bodies
                            </Typography>
                            <Divider />
                            <Typography variant="body1" paragraph>
                                PNF is the governing body for paper football, organizing international and club competitions.
                                The organization is similar to FIFA, but there have not been regional or national federation
                                yet. PNF is responsible to organize the competitions, set and change the game rules for each
                                competition / season, and keep the relationship with other universe federations.
                            </Typography>
                        </Box>

                        <Box id="competitions" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold'>
                                Competitions
                            </Typography>
                            <Divider />
                            <Typography variant="body1" paragraph>
                                Currently, the most prestigious paper football competitions are the PNF World Cup and
                                the PNF Champions League. Similar to FIFA's versions, World Cup is held every 4 years,
                                while Champions League is held annually for the club inside PNF Universe. Lower ranked
                                competitions are PNF Cup and PNF Conference League. For the national team, continental
                                tournaments such as Euro, Copa America, and Asian Cup are also organized.
                            </Typography>
                        </Box>

                        <Box id="see-also" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold'>
                                See also
                            </Typography>
                            <Divider />
                            <List display='none'>
                                <ListItem><Link href="#" underline="hover">PNF</Link></ListItem>
                                <ListItem><Link href="#" underline="hover">PNF Champions League</Link></ListItem>
                                <ListItem><Link href="#" underline="hover">PNF World Cup</Link></ListItem>
                                <ListItem><Link href="#/pnf/List_of_all_PNF_Clubs" underline="hover">List of all PNF Clubs</Link></ListItem>
                            </List>
                        </Box>

                        <Box id="notes" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold'>
                                Notes
                            </Typography>
                            <Divider />
                            <Typography variant="body1" paragraph>
                                [a] Also known as ETS Paper Footgame.
                            </Typography>
                        </Box>

                        <Box id="references" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold'>
                                References
                            </Typography>
                            <Divider />
                            <Typography variant="body1" paragraph>
                                [1] "Replay - Clásicos de fútbol". Retrieved September 30th, 2024.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                [2] "PAPERFOOT - Soccer Boardgame". Retrieved September 30th, 2024.
                            </Typography>
                        </Box>

                        <Box id="external-links" my={4}>
                            <Typography variant="h4" component="h2" gutterBottom fontWeight='bold'>
                                External links
                            </Typography>
                            <Divider />
                            <List>
                                <ListItem><Link href="https://en.wikipedia.org/wiki/Association_football" underline="hover">Association football on Wikipedia</Link></ListItem>
                                <ListItem><Link href="https://www.wikihow.com/Play-Paper-Football" underline="hover">How to Play Paper Football on WikiHow</Link></ListItem>
                            </List>
                        </Box>
                    </Grid>

	                <Grid item xs={12} md={4}>
                        <Box display="flex" justifyContent="center" marginBottom="1vh">
                            <a variant="body1" style={{ fontWeight: 'bold', textAlign: 'center'}}>Paper football</a>
                        </Box>
                        <Paper elevation={3} sx={{ padding: 3, marginBottom: 4, backgroundColor: "#f5f5f5" }}>
                            <img
                                src={Paper_football}
                                alt="Paper Football"
                                style={{ width: '100%', maxWidth: '500px', height: 'auto', margin: '1vh 0 0 0' }}
                            />
                            <Typography variant="h6" component="h3" gutterBottom textAlign="center">
                                The attacking player (No. 22) attempts to take a free-kick and scores the goal.
                            </Typography>
							<Table>
				                <TableBody>
				                    <TableRow>
				                        <TableCell><strong>Highest governing body</strong></TableCell>
				                        <TableCell>PNF (Paper-football Novel Federation)</TableCell>
				                    </TableRow>
				                    <TableRow>
				                        <TableCell><strong>Other names</strong></TableCell>
				                        <TableCell>Paper Foot Game</TableCell>
				                    </TableRow>
				                    <TableRow>
				                        <TableCell><strong>Being well-known for</strong></TableCell>
				                        <TableCell>Appearing in 'Upin & Ipin'</TableCell>
				                    </TableRow>
				                    <TableRow>
				                        <TableCell><strong>Equipment</strong></TableCell>
				                        <TableCell>Paper ball</TableCell>
				                    </TableRow>
				                    <TableRow>
				                        <TableCell><strong>Venue</strong></TableCell>
				                        <TableCell>
				                            <a>Table</a><br/>
				                            <a>Ground</a>
				                        </TableCell>
				                    </TableRow>
				                    <TableRow>
				                        <TableCell><strong>Country or region</strong></TableCell>
				                        <TableCell>Worldwide</TableCell>
				                    </TableRow>
				                </TableBody>
				            </Table>
                        </Paper>
                    </Grid>
	            </Grid>
	        </Container>
	    </ThemeProvider>
    );
}

export default PnfInfo;
